/**
 * @package  	Cavalree_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

if (typeof $ === "undefined") {
  var $ = jQuery;
}

const rootStyles = getComputedStyle(document.documentElement);

let currentScrollPos = () => ({
  x: window.scrollX,
  y: window.scrollY,
});

/*****************************
 * Vanilla JS functions
 *****************************/
// addHeadingNonBreakingSpace();
// detectScrollbarWidth();
detectHeaderHeight();

// END jQuery Ready
function detectScrollbarWidth() {
  /* Detect scrollbar width to properly center full- and wide-width elements */
  let root = document.documentElement;
  var outside = document.createElement("div");
  var inside = document.createElement("div");

  outside.style.width = inside.style.width = "100%";
  outside.style.overflow = "scroll";
  document.body.appendChild(outside).appendChild(inside);

  var scrollbarWidth = outside.offsetWidth - inside.offsetWidth;

  outside.parentNode.removeChild(outside);
  root.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
}

function detectHeaderHeight() {
  let root = document.documentElement;
  var head = document.querySelector("header.site-header");
  var headerHeight = head.offsetHeight;

  if (document.querySelector("body").classList.contains("admin-bar")) {
    headerHeight =
      headerHeight + document.querySelector("#wpadminbar").offsetHeight;
  }

  root.style.setProperty("--head-height", headerHeight + "px");
}

function addHeadingNonBreakingSpace() {
  var headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

  headings.forEach(function (head, index) {
    let str = head.textContent;
    let firstSection = str.substring(0, str.lastIndexOf(" ") + 1);
    let lastSection = str.substring(str.lastIndexOf(" ") + 1, str.length);

    firstSection = firstSection.trim();

    let newStr = firstSection + "\u00a0" + lastSection;

    head.innerHTML = newStr;
  });
}

// END Vanilla JS

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function () {
  siteHeaderChecker(currentScrollPos().y);

  if ($(".block--cav-quick-links").length) {
    quickLinks();
  }

  $(document).resize(function () {
    quickLinks();
    detectHeaderHeight();
  });

  $(window).scroll(function () {
    siteHeaderChecker(currentScrollPos().y);
    detectHeaderHeight();
    quickLinks();
  });

  if ($(".site-alert").length) {
    $(".site-alert button#alertClose").on("click", function (event) {
      event.preventDefault();

      $(this).parents(".site-alert").slideUp();
    });
  }
});

if (document.getElementById("quickLinkSelect")) {
  document
    .getElementById("quickLinkSelect")
    .addEventListener("change", function () {
      var target = new URL(this.value);
      target = target.hash;

      if (target) {
        // Scroll to the corresponding section
        document.querySelector(target).scrollIntoView({
          behavior: "smooth",
        });

        if (window.location.hash !== target) {
          window.location.hash = target;
        }
      }
    });
}

function quickLinks() {
  var element = document.querySelector(
    ".block--cav-quick-links:not(.cav-quick-links--alt)"
  );

  if (element) {
    if (isElementInViewport(element)) {
      console.log("Element is in the viewport");
      document.querySelector(".cav-quick-links--alt").classList.remove("show");
    } else {
      console.log("Element is not in the viewport");
      document.querySelector(".cav-quick-links--alt").classList.add("show");
    }
  }
}

function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function siteHeaderChecker(y) {
  let headHeight = rootStyles
    .getPropertyValue("--head-height")
    .replace("px", "");
  let pos = Number(headHeight) + 50;

  if (y > pos) {
    $("header.site-header").addClass(
      "has-off-white-background-color adjust-padding"
    );
  } else {
    $("header.site-header").removeClass(
      "has-off-white-background-color adjust-padding"
    );
  }
}
